import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem } from "@/components/shared/Reveal";

const FILTERS = [
  "Approximate location", "Availability", "CDL class", "Endorsements", "Equipment experience",
  "Previous assignments", "Marketplace rating", "Qualification status (where appropriate)",
];

export const BrokerFindDrivers = () => (
  <section data-testid="broker-find-drivers-section" className="py-24 md:py-28 bg-rr-surface">
    <div className="max-w-5xl mx-auto px-5 md:px-8">
      <SectionHeading eyebrow="Beyond Your Contact List" title="Expand Beyond Your Existing Contact List." testId="broker-find-drivers" />
      <p className="mt-5 text-rr-muted max-w-2xl">
        Brokers can search eligible RelayRigs driver profiles using configured filters. Sensitive driver information is never exposed publicly.
      </p>
      <RevealStagger className="mt-8 flex flex-wrap gap-2.5">
        {FILTERS.map((f) => (
          <RevealItem key={f}>
            <span data-testid={`broker-find-drivers-filter-${f.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm font-bold px-4 py-2 rounded-full bg-white border border-rr-line text-rr-navy">
              {f}
            </span>
          </RevealItem>
        ))}
      </RevealStagger>
    </div>
  </section>
);
